/* DeLiving compact specifications loader + fixed Maintenance grouping. Duplicate theme only. */
(() => {
  const loaderScript = document.currentScript;
  const STYLE_ID = 'deliving-maintenance-format-styles';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .deliving-upi .deliving-upi-maintenance.deliving-maintenance-formatted {
        padding-top: 2px;
      }
      .deliving-upi .deliving-maintenance-group {
        margin: 0;
      }
      .deliving-upi .deliving-maintenance-group + .deliving-maintenance-group {
        margin-top: 14px;
        padding-top: 13px;
        border-top: 1px solid #eceee9;
      }
      .deliving-upi .deliving-maintenance-group-title {
        margin: 0 0 6px !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
        font-weight: 750 !important;
        color: #30342f !important;
      }
      .deliving-upi .deliving-maintenance-list {
        margin: 0 !important;
        padding-left: 22px !important;
      }
      .deliving-upi .deliving-maintenance-list li {
        margin: 0 !important;
        padding-left: 3px;
        font-size: 12px;
        line-height: 1.55;
        color: #5e625c;
      }
      .deliving-upi .deliving-maintenance-list li + li {
        margin-top: 5px !important;
      }
      .deliving-upi .deliving-maintenance-list li::marker {
        color: #67824f;
        font-weight: 700;
      }
      @media (max-width: 749px) {
        .deliving-upi .deliving-maintenance-group-title {
          font-size: 12.5px !important;
        }
        .deliving-upi .deliving-maintenance-list {
          padding-left: 20px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function cleanStep(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\s+([,.;:!?])/g, '$1')
      .replace(/\.\s*,\s*$/g, '.')
      .replace(/,\s*$/g, '')
      .trim();
  }

  function extractNumberedSteps(value) {
    const steps = [];
    const pattern = /(?:^|[\s,;])(\d+)\s*[.)]\s*([\s\S]*?)(?=(?:[\s,;]+\d+\s*[.)])|$)/g;
    let match;

    while ((match = pattern.exec(value))) {
      const step = cleanStep(match[2]);
      if (step) steps.push(step);
    }

    return steps;
  }

  function parseGroups(raw) {
    // A supplier can join the next material directly to punctuation, for example:
    // "...attachment.Steel: 1.Clean...". Treat punctuation as a valid group boundary.
    const headingPattern = /(^|[\s,;.!?])([A-Za-z][A-Za-z0-9 &/+()'’\-]{1,45})\s*:\s*(?=\d+\s*[.)])/g;
    const headings = [];
    let match;

    while ((match = headingPattern.exec(raw))) {
      headings.push({
        label: match[2].trim(),
        boundaryStart: match.index + match[1].length,
        contentStart: headingPattern.lastIndex,
      });
    }

    if (!headings.length) return [];

    const groups = [];
    headings.forEach((heading, index) => {
      const end = index + 1 < headings.length ? headings[index + 1].boundaryStart : raw.length;
      const steps = extractNumberedSteps(raw.slice(heading.contentStart, end));
      if (steps.length) groups.push({ label: heading.label, steps });
    });

    return groups;
  }

  function formatMaintenance(container) {
    if (!container || container.dataset.delivingMaintenanceFixed === 'true') return;

    const raw = String(container.innerText || container.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!raw) return;

    const groups = parseGroups(raw);
    if (!groups.length) return;

    const fragment = document.createDocumentFragment();

    groups.forEach((group) => {
      const section = document.createElement('section');
      section.className = 'deliving-maintenance-group';

      const title = document.createElement('h4');
      title.className = 'deliving-maintenance-group-title';
      title.textContent = `${group.label}:`;
      section.appendChild(title);

      const list = document.createElement('ol');
      list.className = 'deliving-maintenance-list';

      group.steps.forEach((step) => {
        const item = document.createElement('li');
        item.textContent = step;
        list.appendChild(item);
      });

      section.appendChild(list);
      fragment.appendChild(section);
    });

    container.replaceChildren(fragment);
    container.classList.add('deliving-maintenance-formatted');
    // Make the older formatter in the core file skip this already-correct version.
    container.dataset.delivingMaintenanceFormatted = 'true';
    container.dataset.delivingMaintenanceFixed = 'true';
  }

  function formatAllMaintenance() {
    ensureStyles();
    document.querySelectorAll('.deliving-upi-maintenance').forEach(formatMaintenance);
  }

  let queued = false;
  function queueMaintenance() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      formatAllMaintenance();
    });
  }

  // Deferred theme scripts run after the product markup is parsed, so format once
  // before loading the original compact-specifications core.
  formatAllMaintenance();

  new MutationObserver(queueMaintenance).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Load the untouched previous file so all compact Specifications behaviour and icons remain.
  if (loaderScript && loaderScript.src) {
    const coreUrl = new URL(loaderScript.src, window.location.href);
    coreUrl.pathname = coreUrl.pathname.replace(
      /deliving-compact-specifications\.js$/,
      'deliving-compact-specifications-core.js'
    );
    coreUrl.search = `?v=${Date.now()}`;

    const coreScript = document.createElement('script');
    coreScript.src = coreUrl.toString();
    coreScript.async = false;
    coreScript.onload = queueMaintenance;
    document.head.appendChild(coreScript);
  }
})();
